import BadgingPage from "../page/BadgingPage";
import BadgingAdminPage from "../page/BadgingAdminPage";

export const navigation = [
    { name: 'Pointages', url: '/badging', element:<BadgingPage />, current: true }
]
